export default "__VITE_ASSET__D_5yTX3j__"